module.exports = __webpack_public_path__ + "img/icone_icone_1.c89b2a7d.svg";